export type Faq = { question: string; answer: string[] };

export const faqs: Faq[] = [
  { question: "Is this a physical product?", answer: ["No. PRENATAL TRAINING PRO 2026 is a 100% digital professional resource."] },
  {
    question: "Who is this system for?",
    answer: ["Personal trainers, fitness instructors, strength coaches, gym professionals and prenatal fitness professionals who work with pregnant clients."],
  },
  { question: "Is this a certification?", answer: ["No. It is a professional fitness education and training-planning resource."] },
  { question: "Is this another ebook filled with theory?", answer: ["No. The system focuses on practical workouts, programming and coaching tools."] },
  { question: "Do I have to create the workouts myself?", answer: ["No. Volumes 02, 03 and 04 include 120 complete sessions from Week 1 through Week 40."] },
  { question: "Are exercise modifications included?", answer: ["Yes. The system includes regressions, progressions and practical alternatives."] },
  {
    question: "What additional resources are included?",
    answer: ["5 professional bonuses are included free with your purchase — you can see each one in the Bonuses section above."],
  },
  {
    question: "Do I need a fully equipped gym to use the workouts?",
    answer: ["No. Each workout includes home options and gym options, so you can coach in a commercial gym, a private studio or a client’s home."],
  },
  {
    question: "Does this replace medical care?",
    answer: [
      "No. PRENATAL TRAINING PRO 2026 is a fitness education resource and does not replace medical, obstetric, physical therapy or individualized healthcare guidance.",
    ],
  },
  { question: "How will I receive the product?", answer: ["The complete system is delivered digitally after purchase."] },
];
